import Redirect from './Redirect.container';

export default Redirect;
